import * as React from 'react';

export function useOnMount(onMount: () => any) {
    return React.useEffect(() => {
        if (onMount) {
            // eslint-disable-next-line
            onMount();
        }
    }, []);
}

export function useOnunmount(onUnmount: () => any) {
    return React.useEffect(() => {
        return () => onUnmount && onUnmount();
    }, []);
}
